/**
 * TOTP (RFC 6238) sinh NGAY TRÊN MÁY bằng WebCrypto — không cần mạng.
 *
 * Vì sao không gọi server lấy mã: docs/03 B6 — mất điện VÀ tablet hỏng thì
 * tổ trưởng dùng điện thoại sinh mã luân phiên. Lúc đó có thể không có mạng.
 * Secret nhận một lần khi mở ca (có mạng), sau đó máy tự sinh mã 30 giây/lần
 * y hệt server (`pyotp`), nên server xác minh được dù mã sinh lúc offline.
 *
 * Tham số cố định khớp pyotp mặc định: SHA-1, 6 số, bước 30 giây.
 */

const BASE32 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'

export function giaiBase32(s: string): Uint8Array<ArrayBuffer> {
  const sach = s.toUpperCase().replace(/=+$/, '').replace(/[^A-Z2-7]/g, '')
  const bits: number[] = []
  for (const c of sach) {
    const v = BASE32.indexOf(c)
    for (let i = 4; i >= 0; i--) bits.push((v >> i) & 1)
  }
  // Cấp phát qua ArrayBuffer tường minh: WebCrypto nhận BufferSource, còn
  // `new Uint8Array(n)` được TS suy thành ArrayBufferLike (có thể SharedArrayBuffer)
  const ra = new Uint8Array(new ArrayBuffer(Math.floor(bits.length / 8)))
  for (let i = 0; i < ra.length; i++) {
    let b = 0
    for (let j = 0; j < 8; j++) b = (b << 1) | bits[i * 8 + j]
    ra[i] = b
  }
  return ra
}

/** Mã 6 số cho mốc thời gian (giây UNIX). */
export async function maTOTP(secretBase32: string, giay = Math.floor(Date.now() / 1000),
                             buoc = 30, soChuSo = 6): Promise<string> {
  const khoa = await crypto.subtle.importKey(
    'raw', giaiBase32(secretBase32), { name: 'HMAC', hash: 'SHA-1' }, false, ['sign'],
  )
  const dem = Math.floor(giay / buoc)
  const msg = new Uint8Array(new ArrayBuffer(8))
  // 64-bit big-endian; JS number đủ chính xác tới 2^53, dư cho bộ đếm 30s
  let x = dem
  for (let i = 7; i >= 0; i--) { msg[i] = x & 0xff; x = Math.floor(x / 256) }
  const mac = new Uint8Array(await crypto.subtle.sign('HMAC', khoa, msg))
  const lech = mac[mac.length - 1] & 0x0f
  const so = ((mac[lech] & 0x7f) << 24) | (mac[lech + 1] << 16) | (mac[lech + 2] << 8) | mac[lech + 3]
  return String(so % 10 ** soChuSo).padStart(soChuSo, '0')
}

/** Số giây còn lại của cửa sổ 30 giây hiện tại. */
export function giayConLai(buoc = 30): number {
  return buoc - (Math.floor(Date.now() / 1000) % buoc)
}
